// /mnt/mantenimientos/frontend/src/App.js
import React from "react";
import "./panelTecnico.css";
import "./styles/design-system.css";

import { ClienteProvider } from "./context/ClienteContext";
import TecnicoAppShell from "./layout/TecnicoAppShell";

export default function App() {
  return (
    <ClienteProvider>
      <TecnicoAppShell />
    </ClienteProvider>
  );
}
